import { createSlice } from '@reduxjs/toolkit';
import { interactiveStop, updateTimer } from '../../actions/actions';

/**
 *
 * @typedef {DisplayQueueItem[]} DisplayQueue
 */
export const displayQueue = createSlice({
	name: 'emoji/display queue',
	initialState: [],
	reducers: {
		/**
		 *
		 * @param {DisplayQueue} state
		 * @param {{type: string, payload: string}} action
		 * @return {*}
		 */
		send(state, action) {
			const {
				payload: name,
				meta,
			} = action;
			state.push({
				isOwn: true,
				count: 1,
				name,
				start_time: meta.position,
			});

			if (!meta.isLive) {
				return;
			}

			const indexOfCorrection = state.findIndex((i) => {
				return i.isOwn === false && i.name === name;
			});
			if (indexOfCorrection > -1) {
				state[indexOfCorrection].count -= 1;
			} else {
				state.push({
					isOwn: false,
					count: -1,
					name,
					start_time: void 0,
				});
			}

			return state;
		},
		/**
		 *
		 * @param {DisplayQueue} state
		 * @param {{type: string, payload: DisplayQueueItem[]}} action
		 * @return {*}
		 */
		pushToQueue(state, action) {
			const {
				payload,
			} = action;

			payload.forEach(sumWithState);

			// TODO(kyr): ASAP
			//		Removing zero count objects, it will not to displayed, but can mess store

			function sumWithState({name, count, isOwn = false, start_time}) {
				const indexOfTheSame = state.findIndex((i) => i.name === name && i.isOwn === false);

				if (indexOfTheSame > -1) {
					state[indexOfTheSame].count += count;
					state[indexOfTheSame].start_time = start_time;
				} else {
					if (Math.abs(action.meta.position - start_time) > 2) {
						return;
					}
					state.push({
						name,
						count,
						isOwn,
						start_time
					});
				}
			}
		},
		/**
		 *
		 * @param {DisplayQueue} state
		 * @param {{type:string, payload: DisplayQueueItem[]}}action
		 * @return {*[]|*}
		 */
		clearQueue(state, action) {
			const {
				payload,
			} = action;

			return state.filter((item) => {
				const indexOfSame = payload.findIndex((displayed) => {
					return displayed.name === item.name && displayed.start_time === item.start_time && displayed.count === item.count;
				});

				return indexOfSame === -1;
			});
		},
	},
	extraReducers: {
		[interactiveStop]() {
			return [];
		},
		[updateTimer](state, action) {
			for (let i = 0; i < state.length; i++) {
				const stateElement = state[i];
				if(Math.abs(stateElement.start_time - action.meta.position) > 3){
					state.splice(i, 1);
				}
			}
		}
	}
});
